const ToothGeneration = {
  Child: "Child",
  Adult: "Adult",
  Supernumerary: "Supernumerary",
};

export default ToothGeneration;
